import ElTag from './src/tag.vue';

/* istanbul ignore next */
// eslint-disable-next-line func-names
ElTag.install = function (Vue) {
  Vue.component(ElTag.name, ElTag);
};

export default ElTag;
